import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  notification,
  Row,
  Select,
  Space,
} from "antd"
import React, { useEffect, useRef, useState } from "react"
import styles from "../maintenance.module.css"
import { EditableList } from "../../../compnents/list/EditableList"
import { RootDispatch } from "../../../app/store"
import { useDispatch, useSelector } from "react-redux"
import { stringTrim } from "../../../utils/StringUtils"
import { ExclamationCircleFilled, SearchOutlined } from "@ant-design/icons"
import { Dimen } from "../../../models/dimen"
import { ReportDoctorModal } from "./ReportDoctorModal"
import { DoctorDetailModal } from "./DoctorDetailModal"
import { ApplicationRecord } from "../organization/ApplicationRecord"
import axios from "axios"
import {
  selectAppToken,
  selectCredentials,
  selectUserName,
} from "../../../app/applicationSlice"
import { getAskTypeName, getSJWHTokenAsync } from "../organization/data"
import { unwrapResult } from "@reduxjs/toolkit"

export const DoctorMaintenance = () => {
  const dispatch = useDispatch<RootDispatch>()

  // const token = useSelector(selectAppToken)

  const [token, setToken] = useState('')

  const [params, setParams] = useState<any>({ pageNo: 1, pageSize: 10 })

  const AXIOS_IP = window.location.origin +  "/supervise_proxy/jiangsu/admin-api"

  // const AXIOS_IP = "http://192.168.111.37:9528/jiangsu/admin-api"

  // const AXIOS_IP = "http://153.37.232.237:9200/jiangsu/admin-api"

  const [page, setPage] = useState<any>({ items: [], total: 0 })

  const [pageLoading, setPageLoading] = useState(false)

  const credentials: any = useSelector(selectCredentials)

  const [messageApi, contextHolder] = message.useMessage()

  const [form] = Form.useForm()

  const [visible, setVisible] = useState(false)

  const [type, setType] = useState(4)

  const [isVisible, setIsVisible] = useState(false)

  const [detailVisible, setDetailVisible] = useState(false)

  const [recordVisible, setRecordVisible] = useState(false)

  const [rowData, setRowData] = useState<any>()

  const [recordData, setRecordData] = useState<any>()

  const [reportLoading, setReportLoading] = useState(false)

  const [doctorId, setDoctorId] = useState<any>()

  const { Option } = Select

  const getData = () => {
    setPageLoading(true)
    dispatch(getSJWHTokenAsync())
      .then(unwrapResult)
      .then((token: any) => {
        setToken(token)
        axios({
        url: `${AXIOS_IP}/apply/selectPhysicianApply`,
        headers: {
          "Content-Type": "application/json",
          "His-Auth": token,
        },
        withCredentials: false,
        method: "POST",
        data: {
          ...params,
        },
      }).then((res: any) => {
        if (res.data.data) {
          if (res.data.data?.list?.length > 0 || visible) {
            setVisible(true)
            setPage({
              items: res.data.data.list,
              total: res.data.data.total,
            })
            setPageLoading(false)
          } else {
            setVisible(false)
            setPage({
              items: [],
              total: 0,
            })
            setPageLoading(false)
          }
        }
      })
      })
  }

  useEffect(() => {
    getData()
  }, [params])

  return (
    <Col className={styles.saveform}>
      {contextHolder}
      <div>
        <Row justify="space-between">
          <Col style={{ fontSize: "17px", fontWeight: "bold" }}>
            卫健委平台医生信息
          </Col>
          <Col>
            <Space>
              {!visible && (
                <Button type="link" onClick={() => setRecordVisible(true)}>
                  申请记录
                </Button>
              )}
            </Space>
          </Col>
        </Row>
        {!visible ? (
          <div className={styles.uploadBtn}>
            <p style={{ marginBottom: "37px" }}>
              卫健委平台找不到该机构的医生信息，请先上报医生信息
            </p>
            <Button type="primary" onClick={() => {
              axios({
                    url: `${AXIOS_IP}/apply/queryInstitution`,
                    headers: {
                      "Content-Type": "application/json",
                      "His-Auth": token,
                    },
                    withCredentials: false,
                    method: "GET",
                  }).then((res) => {
                    if(res.data.data?.id) {
                      setIsVisible(true)
                    } else {
                      messageApi.open({
                        type: "warning",
                        content:
                          "请先上报机构信息",
                        className: "custom-class",
                        style: {
                          marginTop: "30vh",
                        },
                      })
                    }
                })
            }}>
              上报医生信息
            </Button>
          </div>
        ) : (
          <Col style={{ marginTop: 16 }}>
            <Form
              form={form}
              name="control-hooks"
              autoComplete="off"
              onFinish={(fs) => {
                setParams({
                  ...params,
                  ...fs,
                })
              }}
            >
              <Row
                gutter={11}
                style={{ height: "42px", position: "relative", zIndex: 999 }}
                wrap={false}
              >
                <Col span={5}>
                  <Form.Item
                    name="physicianName"
                    getValueFromEvent={stringTrim}
                  >
                    <Input
                      placeholder="医生姓名"
                      allowClear
                      prefix={<SearchOutlined />}
                      onChange={form.submit}
                    />
                  </Form.Item>
                </Col>
                <Col span={2}>
                  <Form.Item name="workState">
                    <Select
                      showSearch
                      onChange={form.submit}
                      dropdownClassName={styles.select}
                      placeholder={"医生状态"}
                      allowClear
                    >
                      <Option value={1}>在职</Option>
                      <Option value={0}>离职</Option>
                      <Option value={2}>失效</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={2}>
                  <Form.Item name="state">
                    <Select
                      placeholder="申请状态"
                      dropdownClassName={styles.select}
                      onChange={form.submit}
                      allowClear
                    >
                      <Option value={0}>待审核</Option>
                      <Option value={1}>已审核</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col flex={1}>
                  <Space>
                    <Button
                      htmlType="submit"
                      type="primary"
                      style={{ marginLeft: "10px" }}
                      onClick={form.submit}
                    >
                      查询
                    </Button>
                  </Space>
                </Col>
                <Col>
                  <Space>
                    <Button
                      type="primary"
                      style={{ marginLeft: "10px" }}
                      onClick={() => {
                        setRowData(undefined)
                        setDoctorId("")
                        setIsVisible(true)
                        setType(4)
                      }}
                    >
                      新增医生
                    </Button>
                  </Space>
                </Col>
              </Row>
            </Form>
            <EditableList
              style={{ flex: 1, marginTop: 30 }}
              scroll={{ x: "30rem" }}
              loading={pageLoading}
              page={{
                items: page.items,
                current: params.pageNo,
                size: params.pageSize,
                total: page.total,
              }}
              // onRow={(r) => ({
              //   onDoubleClick: () => {

              //   },
              // })}
              pageSizeOptions={["10", "20", "50", "100"]}
              rowKey={(m: any) => m.id}
              columns={[
                {
                  title: "序号",
                  align: "center",
                  width: Dimen.Num,
                  render: (_1, _2, index) =>
                    `${params.pageSize * (params.pageNo - 1) + index + 1}`,
                },
                {
                  title: "医生姓名",
                  align: "center",
                  dataIndex: "name",
                  ellipsis: true,
                  width: "6rem",
                },
                {
                  title: "身份证号",
                  align: "center",
                  dataIndex: "identityCard",
                  width: "12rem",
                  ellipsis: true,
                },
                {
                  title: "资格证书编号",
                  align: "center",
                  dataIndex: "qualification",
                  width: "12rem",
                  ellipsis: true,
                },
                {
                  title: "执业证书编号",
                  align: "center",
                  dataIndex: "practice",
                  width: "12rem",
                  ellipsis: true,
                },
                {
                  title: "执业范围",
                  align: "center",
                  dataIndex: "practiceArea",
                  width: "8rem",
                  ellipsis: true,
                },
                {
                  title: "状态",
                  align: "center",
                  dataIndex: "workState",
                  width: "4rem",
                  ellipsis: true,
                  render: (_, t) => {
                    return t.workState === 1
                      ? "在职"
                      : t.workState === 2
                      ? "失效"
                      : "离职"
                  },
                },
                {
                  title: "审核状态",
                  align: "center",
                  dataIndex: "state",
                  width: "6rem",
                  ellipsis: true,
                  render: (_, t) => {
                    return t.state == 0
                      ? "待审核"
                      : t.state == 1
                      ? "已审核"
                      : "已撤回"
                  },
                },
                {
                  title: "操作",
                  align: "center",
                  dataIndex: "",
                  width: "28rem",
                  ellipsis: true,
                  render: function Element(_, t) {
                    return (
                      <>
                        <Button
                          type="link"
                          onClick={() => {
                            setRowData(t)
                            setDetailVisible(true)
                          }}
                        >
                          详情
                        </Button>
                        {t.workState != 2 && (
                          <Button
                            type="link"
                            onClick={() => {
                              axios({
                                url: `${AXIOS_IP}/apply/queryPhysicianApplyDetail`,
                                headers: {
                                  "Content-Type": "application/json",
                                  "His-Auth": token,
                                },
                                withCredentials: false,
                                method: "POST",
                                data: {
                                  id: t?.id,
                                },
                              }).then((v: any) => {
                                if(v.data.data?.workState === 2) {
                                  notification.error({
                                    message: "该医生数据已失效，无法进行操作",
                                  })
                                } else {
                                  setRowData(v.data.data)
                                  setDoctorId(v.data.data?.id)
                                  setIsVisible(true)
                                  if (v.data.data?.state == 0) {
                                    setType(v.data.data?.askType)
                                  } else {
                                    setType(3)
                                  }
                                }
                              })
                            }}
                          >
                            申请调整
                          </Button>
                        )}
                        {t.state == 0 && t.workState != 2 && (
                          <Button
                            type="link"
                            onClick={() => {
                              Modal.confirm({
                                centered: true,
                                title: "确认操作",
                                content: (
                                  <div>
                                    <ExclamationCircleFilled
                                      style={{ color: "#FFAE55", fontSize: 18 }}
                                    />
                                    &nbsp;是否确认撤回？
                                  </div>
                                ),
                                okText: "确认",
                                cancelText: "取消",
                                icon: null,
                                onOk: () => {
                                  axios({
                                    url: `${AXIOS_IP}/apply/withdrawPhysicianApply`,
                                    headers: {
                                      "Content-Type": "application/json",
                                      "His-Auth": token,
                                    },
                                    withCredentials: false,
                                    method: "POST",
                                    data: { ...t, state: 2 },
                                  }).then(() => {
                                    notification.success({
                                      message: "操作成功",
                                    })
                                    getData()
                                  })
                                },
                              })
                            }}
                          >
                            申请撤回
                          </Button>
                        )}
                        <Button
                          type="link"
                          onClick={() => {
                            axios({
                              url: `${AXIOS_IP}/apply/queryPhysicianApplicationRecords`,
                              headers: {
                                "Content-Type": "application/json",
                                "His-Auth": token,
                              },
                              withCredentials: false,
                              method: "POST",
                              data: {
                                identityCard: t?.identityCard,
                              },
                            }).then((res: any) => {
                              setRecordData(res.data.data)
                              setRecordVisible(true)
                            })
                          }}
                        >
                          申请记录
                        </Button>
                        {t.workState == 1 ? (
                          <Button
                            type="link"
                            onClick={() => {
                              if (t?.state == 0) {
                                messageApi.open({
                                  type: "warning",
                                  content:
                                    "状态为待审核时不能进行离职申报或重新入职申请",
                                  className: "custom-class",
                                  style: {
                                    marginTop: "10vh",
                                  },
                                })
                                return
                              }
                              Modal.confirm({
                                centered: true,
                                title: "确认操作",
                                content: (
                                  <div>
                                    <ExclamationCircleFilled
                                      style={{ color: "#FFAE55", fontSize: 18 }}
                                    />
                                    &nbsp;是否确认离职申报？
                                  </div>
                                ),
                                okText: "确认",
                                cancelText: "取消",
                                icon: null,
                                onOk: () => {
                                  axios({
                                    url: `${AXIOS_IP}/apply/physicianApplyChangeRecord`,
                                    headers: {
                                      "Content-Type": "application/json",
                                      "His-Auth": token,
                                    },
                                    withCredentials: false,
                                    method: "POST",
                                    data: {
                                      ...t,
                                      workState: 0,
                                      askType: 3,
                                      createTime: undefined,
                                      createUser: credentials?.phone,
                                      updateUser: credentials?.phone,
                                    },
                                  }).then(() => {
                                    notification.success({
                                      message: "操作成功",
                                    })
                                    getData()
                                  })
                                },
                              })
                            }}
                          >
                            离职申报
                          </Button>
                        ) : t.workState == 0 ? (
                          <Button
                            type="link"
                            onClick={() => {
                              if (t?.state == 0) {
                                messageApi.open({
                                  type: "warning",
                                  content:
                                    "状态为待审核时不能进行离职申报或重新入职申请",
                                  className: "custom-class",
                                  style: {
                                    marginTop: "35vh",
                                  },
                                })
                                return
                              }
                              Modal.confirm({
                                centered: true,
                                title: "确认操作",
                                content: (
                                  <div>
                                    <ExclamationCircleFilled
                                      style={{ color: "#FFAE55", fontSize: 18 }}
                                    />
                                    &nbsp;是否确认重新入职？
                                  </div>
                                ),
                                okText: "确认",
                                cancelText: "取消",
                                icon: null,
                                onOk: () => {
                                  axios({
                                    url: `${AXIOS_IP}/apply/physicianApplyChangeRecord`,
                                    headers: {
                                      "Content-Type": "application/json",
                                      "His-Auth": token,
                                    },
                                    withCredentials: false,
                                    method: "POST",
                                    data: {
                                      ...t,
                                      workState: 1,
                                      askType: 3,
                                      createTime: undefined,
                                      createUser: credentials?.phone,
                                      updateUser: credentials?.phone,
                                    },
                                  }).then(() => {
                                    notification.success({
                                      message: "操作成功",
                                    })
                                    getData()
                                  })
                                },
                              })
                            }}
                          >
                            重新入职
                          </Button>
                        ) : (
                          <></>
                        )}
                      </>
                    )
                  },
                },
              ]}
              onChangePage={(current, size) =>
                setParams({ ...params, pageNo: current, pageSize: size || 10 })
              }
              sticky
            />
          </Col>
        )}
      </div>

      <ReportDoctorModal
        visible={isVisible}
        reportLoading={reportLoading}
        data={rowData}
        onCancel={() => setIsVisible(false)}
        onOk={(v) => {
          setReportLoading(true)
          axios({
            url: doctorId
              ? `${AXIOS_IP}/apply/physicianApplyChangeRecord`
              : `${AXIOS_IP}/apply/reportPhysician`,
            headers: {
              "Content-Type": "application/json",
              "His-Auth": token,
            },
            withCredentials: false,
            method: "POST",
            data: {
              ...v,
              applyUser: credentials?.name,
              createUser: credentials?.phone,
              updateUser: credentials?.phone,
              askType: type, //信息调整3 上报 4,
              id: doctorId || undefined,
              state: doctorId ? rowData?.state : undefined,
            },
          })
            .then(() => {
              notification.success({
                message: "操作成功",
              })
              setIsVisible(false)
              setParams({ ...params, pageNo: 1 })
            })
            .then(() => {
              setReportLoading(false)
            })
        }}
      />

      <DoctorDetailModal
        visible={detailVisible}
        detail={rowData}
        onCancel={() => setDetailVisible(false)}
        onOk={() => setDetailVisible(false)}
      />

      <ApplicationRecord
        visible={recordVisible}
        type={2}
        data={recordData}
        onCancel={() => setRecordVisible(false)}
      />
    </Col>
  )
}
